module.exports = __webpack_public_path__ + "static/sarah-florian-such-portrait-both-b81343f271a3d1ff28427ec1e149b535.jpg";